import React from "react";

/**
 * Legend chip — tiny always-visible key naming what the viewfinder tints mean.
 * Sits under the viewfinder so brand-new students decode the feedback in one glance.
 */
const Item = ({ swatch, label, testid }) => (
    <span
        className="flex items-center gap-1.5 text-[10px] tracking-[0.18em] uppercase text-[var(--text-secondary)] font-mono whitespace-nowrap"
        data-testid={testid}
    >
        <span
            className="inline-block h-2.5 w-2.5 rounded-sm"
            style={swatch}
            aria-hidden="true"
        />
        {label}
    </span>
);

export const Legend = () => (
    <div
        className="flex flex-wrap items-center gap-x-4 gap-y-1.5 border border-amber-30 bg-black/40 px-3 py-2"
        role="note"
        aria-label="Viewfinder colour legend"
        data-testid="viewfinder-legend"
    >
        <span className="text-[9px] tracking-[0.25em] uppercase text-amber font-mono">
            Key
        </span>
        <Item
            swatch={{ background: "rgba(160, 30, 0, 0.7)" }}
            label="Red tint = Under-exposed"
            testid="legend-under"
        />
        <Item
            swatch={{ background: "rgba(255, 245, 220, 0.85)", border: "1px solid rgba(255,255,255,0.6)" }}
            label="White wash = Over-exposed"
            testid="legend-over"
        />
        <Item
            swatch={{ background: "var(--crt-green)", boxShadow: "0 0 6px var(--crt-green)" }}
            label="OK badge = Correct"
            testid="legend-ok"
        />
        <Item
            swatch={{
                background: "repeating-linear-gradient(45deg, rgba(255,255,255,0.4) 0 1px, transparent 1px 2px), #1a1010",
            }}
            label="Grain = ISO noise"
            testid="legend-noise"
        />
    </div>
);

export default Legend;
